<template>
  <patient-profile>
    <template v-slot:head>
      <button
        v-if="planList.length"
        class="patient-profile__plans__button-add"
        type="button"
        v-on:click="openFormPlanCreation"
      >Новый план</button>
    </template>
    <div class="patient-plans__section">
      <div class="patient-profile__plans__filters">
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByAllStatus"
          v-bind:value="$options.filterByAllStatus"
          v-model="filterByStatus">
        <label
          class="patient-profile__plans__filters__item"
          v-bind:for="$options.filterByAllStatus">Все</label>
        <input
          v-bind:id="$options.filterByDraftStatus"
          hidden
          type="radio"
          v-bind:value="$options.filterByDraftStatus"
          v-model="filterByStatus">
        <label
          class="patient-profile__plans__filters__item icons draft"
          v-bind:for="$options.filterByDraftStatus">Черновик ({{ draftCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByToBeAgreedStatus"
          v-bind:value="$options.filterByToBeAgreedStatus"
          v-model="filterByStatus">
        <label
          class="patient-profile__plans__filters__item icons to_be_agreed"
          v-bind:for="$options.filterByToBeAgreedStatus"
        >На согласовании ({{ toBeAgreedCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByAcceptedForWorkStatus"
          v-bind:value="$options.filterByAcceptedForWorkStatus"
          v-model="filterByStatus">
        <label
          class="patient-profile__plans__filters__item icons accepted_for_work"
          v-bind:for="$options.filterByAcceptedForWorkStatus"
        >Согласован ({{ acceptToWorkCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByPlanInWorkStatus"
          v-bind:value="$options.filterByPlanInWorkStatus"
          v-model="filterByStatus">
        <label
          class="patient-profile__plans__filters__item icons in_work"
          v-bind:for="$options.filterByPlanInWorkStatus"
        >В работе ({{ inWorkCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByCompletedStatus"
          v-bind:value="$options.filterByCompletedStatus"
          v-model="filterByStatus">
        <label
          class="patient-profile__plans__filters__item icons completed"
          v-bind:for="$options.filterByCompletedStatus"
        >Выполнен ({{ completedCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByCanceledByPatientStatus"
          v-bind:value="$options.filterByCanceledByPatientStatus"
          v-model="filterByStatus">
        <label
          class="patient-profile__plans__filters__item icons canceled_by_patient"
          v-bind:for="$options.filterByCanceledByPatientStatus"
        >Отклонен пациентом ({{ cancelByPatientCount }})</label>
      </div>
      <div class="patient-profile__plans__table">
        <form class="patient-profile__plans__table__head">
          <div class="patient-profile__plans__table__cell">Название плана</div>
          <input-sort
            name="card"
            v-model="sortByDate"
            v-on:input="onSortByDateChanged"
          >
            <div
              class="patient-profile__plans__table__cell sort"
              v-bind:class="{ selected: !!sortByDate }"
            >Дата создания
            </div>
          </input-sort>
          <div v-if="hasBranchSystem" class="patient-profile__plans__table__cell">Филиал</div>
          <div class="patient-profile__plans__table__cell author">Автор</div>
          <div class="patient-profile__plans__table__cell">Специализация</div>
          <input-sort
            class="patient-profile__plans__table__cell sort"
            v-bind:class="{ selected: !!sortBySum }"
            name="card"
            v-model="sortBySum"
            v-on:input="onSortBySumChanged"
          >
            <div>Сумма</div>
          </input-sort>
          <div class="patient-profile__plans__table__cell status">Статус</div>
          <div class="patient-profile__plans__table__cell" />
        </form>
        <button
          class="patient-profile__plans__table__row"
          type="button"
          v-bind:key="plan.id"
          v-for="plan in planList"
          v-on:click="openPlan(plan.id)"
        >
          <div
            class="patient-profile__plans__table__cell"
            data-label="Название плана">{{ plan.name }}</div>
          <div
            class="patient-profile__plans__table__cell"
            data-label="Дата создания">{{ plan.date }}</div>
          <div
            v-if="hasBranchSystem"
            class="patient-profile__plans__table__cell"
            data-label="Филиал">{{ plan.branchName }}</div>
          <div
            class="patient-profile__plans__table__cell author"
            data-label="Автор">{{ plan.authorName }}</div>
          <div
            class="patient-profile__plans__table__cell"
            data-label="Специализация">{{ plan.authorSpeciality }}</div>
          <div
            class="patient-profile__plans__table__cell"
            data-label="Сумма">{{ plan.price }}</div>
          <div
            data-label="Статус"
            class="patient-profile__plans__table__cell icons status"
            v-bind:class="plan.statusId.toLowerCase()"
          >{{ getStatusName(plan.statusId) }}</div>
          <button
            class="patient-profile__plans__table__cell copy"
            title="Дублировать план лечения"
            type="button"
            v-on:click.stop="onClickCopyButton(plan.id)"
          ><img alt="Копировать план" src="@/assets/img/copy-grey.svg">
          </button>
        </button>
        <button
          v-if="isEmpty"
          class="patient-profile__empty"
          type="button"
          v-on:click="openFormPlanCreation"
        >
          Создать план лечения
        </button>
      </div>
    </div>
    <modal-dialog
      max-width="500px"
      v-bind:title="confirmCopyPlanDialogTitle"
      v-bind:value="isShowConfirmCopyPlanDialog"
      v-on:cancel=closeConfirmCopyPlanDialog
    >
      <confirm-modal
        cancel-title="Отмена"
        confirm-title="Продолжить"
        v-on:on-cancel="closeConfirmCopyPlanDialog"
        v-on:on-confirm="onClickConfirmPlan"
      />
    </modal-dialog>

  </patient-profile>
</template>

<script>
import InputSort from '@/components/InputSort.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import notifierMixin from '@/mixins/notifierMixin';
import patientPlanMixin from '@/mixins/patientPlanMixin';
import metricMixin from '@/mixins/metricMixin';
import { GOAL_CLICK_FILTER_PATIENT_PLAN, GOAL_CREATE_PATIENT_PLAN } from '@/plugins/metric';
import ModalDialog from '@/components/ModalDialog.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

export default {
  components: {
    ConfirmModal,
    ModalDialog,
    InputSort,
    PatientProfile,
  },
  computed: {
    /**
     * @description Заголовок диалога подтверждения копирования плана
     * @returns {string}
     */
    confirmCopyPlanDialogTitle() {
      return `Некоторых услуг нет в прайсе ${this.branchName}. Они будут удалены из плана лечения. Продолжить?`;
    },
    /**
     * Имеет филиальную систему.
     * @returns {boolean}
     */
    hasBranchSystem() {
      return this.$store.getters.isSectionAvailable('branch-system');
    },
    /**
     * @description Список планов пуст.
     * @type {boolean}
     */
    isEmpty() {
      return this.planList.length === 0 && this.isLoading === false;
    },
    /**
     * @description Идентификатор пациента.
     * @type {number}
     */
    patientId() {
      return parseInt(this.$route.params.id, 10);
    },
    /**
     * @description Запрос на просмотр.
     * @type {any}
     */
    viewQuery({
      sortBy, orderBy, filterByStatus,
    }) {
      return {
        filterByStatus,
        sortBy,
        orderBy,
      };
    },
  },
  created() {
    this.fetchPlanStatuses();
    this.reloadPlanList();
  },
  data() {
    const filterByStatus = this.$options.filterByAllStatus;
    return {
      /**
       * @description Ожидается ли ответ по запросу дублирования плана лечения
       * @type boolean
       */
      isAwaitDuplicateRequest: false,
      /**
       * @description Наименование филиала
       * @type {string}
       */
      branchName: '',
      /**
       * @description Копируемый Id плана
       * @type {Number|null}
       */
      copyPlanId: null,
      /**
       * @description Показывать ли модальное окно копирования плана
       * @type {boolean}
       */
      isShowConfirmCopyPlanDialog: false,
      /**
       * @description Ожидание окончания загрузки.
       * @type {boolean}
       */
      isLoading: false,
      /**
       * @description Список планов пациента.
       * @type {PlanItem[]}
       */
      planList: [],
      /**
       * @description Статусы планов.
       * @type {any[]}
       */
      planStatuses: [],
      /**
       * @description Порядок сортировки по дате.
       * @type {string}
       */
      sortByDate: '',
      /**
       * @description Порядок сортировки по сумме.
       * @type {string}
       */
      sortBySum: '',
      /**
       * @description Фильтровать по статусу.
       * @type {string}
       */
      filterByStatus,
      /**
       * @description Порядок сортировки.
       * @type {string}
       */
      orderBy: '',
      /**
       * @description Столбец для сортировки.
       * @type {string}
       */
      sortBy: '',
      /**
       * @description Количество планов со статусом "Принят в работу"
       * @type {number}
       */
      acceptToWorkCount: 0,
      /**
       * @description Количество планов со статусом "Отклонен пациентом"
       * @type {number}
       */
      cancelByPatientCount: 0,
      /**
       * @description Количество планов со статусом "Выполнен"
       * @type {number}
       */
      completedCount: 0,
      /**
       * @description Количество планов со статусом "Черновик"
       * @type {number}
       */
      draftCount: 0,
      /**
       * @description Количество планов со статусом "В работе"
       * @type {number}
       */
      inWorkCount: 0,
      /**
       * @description Количество планов со статусом "На согласовании"
       * @type {number}
       */
      toBeAgreedCount: 0,
    };
  },
  /**
   * @description Фильтровать по всем статусам.
   * @type {string}
   */
  filterByAllStatus: 'ALL',
  /**
   * @description Фильтровать по черновикам.
   * @type {string}
   */
  filterByDraftStatus: 'DRAFT',
  /**
   * @description Фильтровать по планам в работе.
   * @type {string}
   */
  filterByPlanInWorkStatus: 'IN_WORK',
  /**
   * @description Фильтровать по принятым в работу планам.
   * @type {string}
   */
  filterByAcceptedForWorkStatus: 'ACCEPTED_FOR_WORK',
  /**
   * @description Фильтровать по планам находящихся на согласовании.
   * @type {string}
   */
  filterByToBeAgreedStatus: 'TO_BE_AGREED',
  /**
   * @description Фильтровать по планам отклоненных пациентами.
   * @type {string}
   */
  filterByCanceledByPatientStatus: 'CANCELED_BY_PATIENT',
  /**
   * @description Фильтровать по планам находящихся на согласовании.
   * @type {string}
   */
  filterByCompletedStatus: 'COMPLETED',
  /**
   * @description Сортировать по дате.
   * @type {string}
   */
  sortByDate: 'date',
  /**
   * @description Сортировать по сумме.
   * @type {string}
   */
  sortBySum: 'sum',
  methods: {
    /**
     * @description Обработать событие клинка по кнопку копировать
     * @param {string} planId
     * @returns {void}
     */
    onClickCopyButton(planId) {
      const isNeedConfirm = this
        .planList
        .find((p) => p.id === planId)
        ?.hasServicesFromAnotherBranch;
      if (isNeedConfirm) {
        this.openConfirmCopyPlanDialog();
        this.copyPlanId = planId;
        return;
      }
      this.copyPlanId = planId;
      this.duplicatePlan();
    },
    /**
     * @description Обработать событие подтверждения копирования плана
     * @returns {void}
     */
    onClickConfirmPlan(planId) {
      this.duplicatePlan(planId);
    },
    /**
     * @description Закрыть модальное окно подтверждения копирования плана
     * @returns {void}
     */
    closeConfirmCopyPlanDialog() {
      this.isShowConfirmCopyPlanDialog = false;
    },
    /**
     * @description открыть диалог подтверждения копирования плана
     * @returns {void}
     */
    openConfirmCopyPlanDialog() {
      this.isShowConfirmCopyPlanDialog = true;
    },
    /**
     * @description Дублировать план лечения
     * @returns {void}
     */
    duplicatePlan() {
      if (!this.copyPlanId) {
        return;
      }
      this.isAwaitDuplicateRequest = true;
      const onSuccess = ({ message }) => {
        this.notifySuccess(message);
        this.reloadPlanList();
        this.closeConfirmCopyPlanDialog();
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$planGateway
        .duplicatePlan(this.copyPlanId)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitDuplicateRequest = false;
        });
    },
    /**
     * @description Получить название статуса.
     * @param {string} statusId Идентификатор статуса.
     * @returns {string}
     */
    getStatusName(statusId) {
      const status = this.planStatuses.find((item) => item.value === statusId);
      return status ? status.text : '-';
    },
    /**
     * @description Перезагрузить список планов.
     * @returns {void}
     */
    reloadPlanList() {
      const onResponse = (result) => {
        result.forEach((data) => {
          this.planList = data.list.map((item) => ({ ...item, price: item.price.replace('т.', '₸') }));
          this.acceptToWorkCount = data.acceptToWorkCount;
          this.cancelByPatientCount = data.cancelByPatientCount;
          this.completedCount = data.completedCount;
          this.draftCount = data.draftCount;
          this.inWorkCount = data.inWorkCount;
          this.toBeAgreedCount = data.toBeAgreedCount;
          this.branchName = data.branchName;
        });
        result.forEachFail((error) => {
          const title = error.getTitle();
          if (title) {
            this.notifyFail(title);
          }
        });
      };
      this.isLoading = true;
      this.$planGateway
        .viewList(this.patientId, this.viewQuery)
        .then(onResponse)
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * @description Создать план.
     * @returns {void}
     */
    openFormPlanCreation() {
      const to = this.getFormCreationLocation(this.patientId);
      this.reachGoalIfNotReach(GOAL_CREATE_PATIENT_PLAN);
      this.$router.push(to);
    },
    /**
     * @description Сбросить сортировку.
     * @returns {void}
     */
    resetSorting() {
      this.sortByDate = '';
      this.sortBySum = '';
      this.orderBy = '';
      this.sortBy = '';
    },
    /**
     * @description Обработать изменение порядка сортировки по дате создания.
     * @param {string} order Порядок.
     * @returns {void}
     */
    onSortByDateChanged(order) {
      this.resetSorting();
      this.sortByDate = order;
      this.sortBy = this.$options.sortByDate;
      this.orderBy = order;
    },
    /**
     * @description Обработать изменение порядка сортировки по сумме стоимости услуг плана.
     * @param {string} order Порядок.
     * @returns {void}
     */
    onSortBySumChanged(order) {
      this.resetSorting();
      this.sortBySum = order;
      this.sortBy = this.$options.sortBySum;
      this.orderBy = order;
    },
    /**
     * @description Открыть план.
     * @param {number} planId Идентификатор плана.
     * @returns {void}
     */
    openPlan(planId) {
      const to = this.getLocation(this.patientId, planId);
      this.$router.push(to);
    },
    /**
     * @description Получить статусы плана лечения.
     * @returns {void}
     */
    fetchPlanStatuses() {
      this.$planGateway.getAllStatuses().then((items) => {
        this.planStatuses = items;
      });
    },
  },
  mixins: [notifierMixin, patientPlanMixin, metricMixin],
  name: 'ClinicPanelPatientPlanList',
  watch: {
    filterByStatus: {
      handler() {
        this.reachGoalIfNotReach(GOAL_CLICK_FILTER_PATIENT_PLAN);
      },
    },
    viewQuery: 'reloadPlanList',
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.patient {
  &-profile {
    &__empty {
      @include buttons.btn-blue(250px, 44px, 16px);
      margin: 50px 0 0 0;
    }
    &__plans {
      &__button-add {
        @include buttons.btn-blue(100%, 48px, 16px);
        @include buttons.btn-blue-add(16px);
        max-width: 299px;
      }
      &__filters {
        margin-top: 37px;
        display: flex;
        flex-flow: row wrap;
        gap: 6px;
        &__item {
          display: flex;
          align-items: center;
          color: var(--reading-color);
          font-size: 14px;
          line-height: 17px;
          height: 38px;
          padding: 8px 15px;
          border: 1px solid #c2cfe0;
          border-radius: 4px;
          cursor: pointer;
          &:hover {
            border-color: var(--action-color);
            border-width: 2px;
            padding: 7px 14px;
          }
        }
        input:checked + &__item {
          border-color: var(--action-color);
          border-width: 2px;
          padding: 7px 14px;
        }
      }
      &__table {
        counter-reset: counterEmployees;
        margin: 25px 0 0 0;
        overflow-x: auto;
        &__head,
        &__row {
          display: grid;
          grid-template-columns: 300px minmax(130px, 200px) repeat(auto-fill, minmax(150px, 1fr)) 35px;
          width: 100%;
          min-width: 1100px;
          align-items: center;
          font-size: 14px;
          line-height: 17px;
        }
        &__head {
          font-weight: 700;
          border-bottom: 2px solid #0489e0;
        }
        &__row {
          text-align: left;
          border-bottom: 1px solid #eaeff3;
          &:hover {
            background: #eaeff3;
            .patient-profile__plans__table__cell {
              background: #eaeff3;
            }
          }
        }
        &__cell {
          transition: color var(--animate-duration);
          padding: 12px 8px;
          &.sort {
            text-align: left;
            cursor: pointer;
            display: flex;
            align-items: center;
            &:after {
              content: "";
              background-image: url("@/assets/img/checked/checked-grey.svg");
              background-repeat: no-repeat;
              background-size: contain;
              background-position: center;
              width: 10px;
              height: 10px;
              margin: 0 0 0 5px;
            }
            &:hover {
              text-decoration: none;
            }

            > span.selected {
              color: #0569ac;
            }
          }

          &.status {
            grid-column: -3/-2;
          }
          display: flex;
          align-items: center;
          &.in_work,
          &.accepted_for_work,
          &.completed {
            background-color: #e4ffec;
            height: 100%;
          }
          &.to_be_agreed {
            background-color: #fff7ce;
            height: 100%;
          }
          &.canceled_by_patient {
            background-color: #FFECEC;
            height: 100%;
          }
        }
      }
    }
  }
}

.icons {
  &.accepted_for_work:before,
  &.in_work:before,
  &.completed:before {
    content: "";
    height: 20px;
    margin-right: 10px;
    width: 20px;
  }
  &.in_work:before {
    margin-left: -5px;
    margin-right: 5px;
  }
  &.canceled_by_patient:before {
    content: "";
    margin-left: -5px;
    background-image: url("@/assets/img/exit-red.svg");
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }
  &.completed:before {
    border-radius: 50%;
    content: "";
    height: 6px;
    width: 6px;
    background-color: #29A34B;
  }
  &.accepted_for_work:before {
    background-image: url("@/assets/img/checked/checked-green.svg");
    background-repeat: no-repeat;
    background-size: contain;
    height: 15px;
    width: 15px;
  }
  &.in_work:before {
    background-image: url("@/assets/img/checked/all-checked-green.svg");
    background-repeat: no-repeat;
    background-size: contain;
  }
  &.draft:before {
    background-color: #abb1a3;
    border-radius: 50%;
    content: "";
    height: 6px;
    width: 6px;
    margin-right: 10px;
  }
  &.to_be_agreed:before {
    border-radius: 50%;
    border: 2px solid #faa525;
    content: "";
    height: 10px;
    width: 10px;
    margin-right: 10px;
  }
}
@media screen and (max-width: 1560px) {
  .patient {
    &-profile {
      &__plans {
        &__table {
          &__head,
          &__row {
            grid-template-columns: minmax(140px, 1fr) 140px 140px 150px 200px 150px 150px 25px;
          }
          &__cell {
            &.status {
              grid-column: auto;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .patient-profile__plans__table {
    &__head {
      display: none;
    }
    &__row {
      border: 1px solid #eaeff3;
      grid-template-columns: 1fr;
      grid-gap: 5px;
      min-width: auto;
      margin: 0 0 30px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 2px 8px;
      &.align {
        text-align: left;
      }
      &.icons {
        justify-content: flex-end;
      }
    }
    &__cell:before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
    }
  }
}
</style>
